import { render, staticRenderFns } from "./LfBlueTitleComponent.vue?vue&type=template&id=48e2492d&scoped=true"
import script from "./LfBlueTitleComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LfBlueTitleComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LfBlueTitleComponent.vue?vue&type=style&index=0&id=48e2492d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2492d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e2492d')) {
      api.createRecord('48e2492d', component.options)
    } else {
      api.reload('48e2492d', component.options)
    }
    module.hot.accept("./LfBlueTitleComponent.vue?vue&type=template&id=48e2492d&scoped=true", function () {
      api.rerender('48e2492d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderTitle/LfBlueTitleComponent.vue"
export default component.exports